import React, { FC, useEffect, useContext, useState } from 'react';

import { GlobalContext } from '../../../store';
import { IAdminEvent } from '../../../store/admin/events/store';
import { IAdminClub } from '../../../store/admin/clubs/store';

import { Subheader } from '../Common/Subheader/Subheader';
import { SeasonList } from './SeasonList/SeasonList';
import SeasonOverview from './SeasonOverview/SeasonOverview';
import { useRouteInfoState } from '../../../components/RouteInfo/Context/RouteInfo.context';
import { useEventsByYearAndMonth } from './useEventsByYearAndMonth';

const ListEvents: FC = () => {
  const {
    actions: {
      seasons: { setCurrent },
      adminEvents: { all: getAdminEvents },
      adminClubs: { get: getAdminClubs }
    },
    adminClubs,
    adminEvents: events,
    seasons
  } = useContext(GlobalContext);

  const { clubId } = useRouteInfoState();

  const [club, setClub] = useState<IAdminClub>();
  const [clubEvents, setClubEvents] = useState<IAdminEvent[]>([]);

  const currentSeason = clubId && seasons[clubId] ? seasons[clubId].currentSeason : undefined;

  const eventsByYearAndMonth = useEventsByYearAndMonth(clubEvents, currentSeason);

  useEffect(() => {
    if (clubId) {
      getAdminEvents(clubId).catch();
      getAdminClubs(clubId);
    }
  }, [clubId, getAdminClubs, getAdminEvents]);

  useEffect(() => {
    if (adminClubs && adminClubs[Number(clubId)]) {
      setClub(adminClubs[Number(clubId)]);
    }
  }, [adminClubs, clubId]);

  useEffect(() => {
    if (Object.values(events.all).length > 0) {
      const newClubEvents = Object.values(events.all).filter(e => e.club === Number(clubId));

      setClubEvents(newClubEvents);
    }
  }, [events.all, clubId]);

  return (
    <div className="list-events admin-layout">
      {club && <Subheader clubId={club.id} profileImage={club.profileImage} title="Events" />}

      <SeasonOverview
        clubId={Number(clubId)}
        events={clubEvents}
        seasons={seasons}
        onSeasonChange={setCurrent}
      />

      {eventsByYearAndMonth &&
        Object.keys(eventsByYearAndMonth)
          .sort()
          .reverse()
          .map(year => (
            <SeasonList
              key={`SeasonList-${year}`}
              eventsByMonth={eventsByYearAndMonth[Number(year)]}
            />
          ))}
    </div>
  );
};

export default ListEvents;
